import { firestore } from './../../firebase/utils';

export const handleAddAppt = (id, appt) => {
	return new Promise((resolve, reject) => {
	  firestore
		.collection('users')
		.doc(id)
		.collection('appointments')
		.doc()
		.set(appt)
		.then(() => {
		  resolve();
		})
		.catch(err => {
		  reject(err);
		})
	});
}

export const handleFetchAppts = (id) => {
	return new Promise((resolve, reject) => {
  
	  let ref = firestore
	  				.collection('users')
					.doc(id)
					.collection('appointments')
					.orderBy('startDate', 'asc')
  
	  ref
		.get()
		.then(snapshot => {
		
  
		  const apptData = [
	
			...snapshot.docs.map(doc => {
			  return {
				...doc.data(),
				documentID: doc.id
			  }
			})
		  ];
  
		  resolve({
			apptData
		  });
		})
		.catch(err => {
		  reject(err);
		})
	})
}

export const handleFetchAllAppts = () => {
	return new Promise((resolve, reject) => {
  
	  let ref = firestore
	  				
					.collectionGroup('appointments')
					.orderBy('startDate', 'asc')
  
	  ref
		.get()
		.then(snapshot => {
		
  
		  const apptData = [
	
			...snapshot.docs.map(doc => {
			  return {
				...doc.data(),
				documentID: doc.id
			  }
			})
		  ];
  
		  resolve({
			apptData
		  });
		})
		.catch(err => {
		  reject(err);
		})
	})
}

export const handleDeleteAppt = (id, documentID) => {
	return new Promise((resolve, reject) => {
	  firestore
		.collection('users')
		.doc(id)
		.collection('appointments')
		.doc(documentID)
		.delete()
		.then(() => {
		  console.log(documentID, 2)
		  resolve();
		})
		.catch(err => {
		  reject(err);
		})
	});
}

export const handleUpdateAppt = (id, documentID, appt) => {
	return new Promise((resolve, reject) => {
	  firestore
	  	.collection('users')
	  	.doc(id)
	  	.collection('appointments')
	  	.doc(documentID)
		.update(appt)
		.then(() => {
		  resolve();
		})
		.catch(err => {
		  reject(err);
		}
		
		)
	});
}

export const handleFetchAppt = (apptID) => {
	return new Promise((resolve, reject) => {
	  firestore
		.collection('appointments')
		.doc(apptID)
		.get()
		.then(snapshot => {
  
		  if (snapshot.exists) {
			resolve({
			  ...snapshot.data(),
			  documentID: apptID
			});
		  }
		})
		.catch(err => {
		  reject(err);
		})
	})
}